<template>
    <div>
        {{ __('with_selected') }}:
        <b-dropdown :text="__('export')" size="sm" class="mb-0 export-button" variant="primary">
            <b-dropdown-item :disabled="disabled" @click="bulkAction('export-xls')">XLS</b-dropdown-item>
            <b-dropdown-item :disabled="disabled" @click="bulkAction('export-pdf')">PDF</b-dropdown-item>
            <b-dropdown-item :disabled="disabled" @click="bulkAction('export-csv')">CSV</b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
    export default {
        name: 'bulk-action',
        props: [ 'url', 'ids', 'table', 'param', 'data', 'table_title', 'disabled'],
        methods: {
            bulkAction: function(type) {
                let ext = type.split('-').pop();

                const data = {
                    table: this.table,
                    action_type: type,
                    table_title:this.table_title,
                };

               data[this.param] = this.ids;

                if(this.data != undefined) {
                    data['data'] = this.data
                }
                    this.axios({
                        method: 'post',
                        url: this.url,
                        data: data,
                        responseType: 'blob',
                    }).then((response) => {

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        var dt = new Date();
                        var file_name = 'export_' + (`${
                            dt.getFullYear().toString().padStart(4, '0')}_${
                            (dt.getMonth()+1).toString().padStart(2, '0')}_${
                            dt.getDate().toString().padStart(2, '0')}_${
                            dt.getHours().toString().padStart(2, '0')}${
                            dt.getMinutes().toString().padStart(2, '0')}${
                            dt.getSeconds().toString().padStart(2, '0')}`
                         )+'.';
                        link.setAttribute('download', file_name + ext);
                        document.body.appendChild(link);
                        link.click();
                    });
            }
        }
    }
</script>

<style>
    .export-button {
        font-size: 0.8rem;
    }

    ul:focus{
        outline: none;
    }
</style>
